import React from "react";
import { connect } from "react-redux";
import { v4 } from "uuid";
import { getIcon } from "../../../Components/Functions";
import Layout from "../../../Components/Layout";
import { PERMISSIONS } from "../../../Constants/main";
import { routers } from "../../../Constants/routers";
import {
	updateMyPatientsFilters,
	updateRecords,
} from "../../../Redux/MyPatients/actions";
import { openPanel } from "../../../Redux/Panels/RightPanel/actions";
import ViewPatientProfile from "../../patient/profile_viewer/ViewPatientProfile";



export const MyPatientItem = (props) => {
  const handleOpenProfile = () => {
    props.openPanel({
      title: `Profile: ${props?.name}`,
      content: ViewPatientProfile({
        id: props?.id,
		patient: props,
        callback: () => {},
      }),
	  customClassName: "view-patient-profile",
    });
  };

	return (
		<div className="column is-3">
			<div className="grid-item">
				<div className="h-avatar is-big">
					<img
						className="avatar"
						src={
							props?.image ||
							require("../../../assets/images/placeholder.png").default
						}
						alt=""
					/>
					<div
						className="badge bg-success"
						style={{ width: 20, height: 20, borderRadius: 20 }}
					/>
				</div>
				<h3 className="dark-inverted" data-filter-match>
					{props?.name}
				</h3>
				<p data-filter-match>@{props?.username}</p>
				{!props?.hideControls && (
				<div className="buttons mt-3 d-flex">
					<button 
            onClick={handleOpenProfile}
            className="button h-button is-dark-outlined">
						<span
							className="icon"
							dangerouslySetInnerHTML={{ __html: getIcon("user") }}
						></span>
						<span>Profile</span>
					</button>
					<a
						href={routers.dashboard.messanger(props?.username)}
						className="button h-button is-dark-outlined"
					>
						<span
							className="icon"
							dangerouslySetInnerHTML={{ __html: getIcon("message-circle") }}
						></span>
						<span>Chat</span>
					</a>
				</div>
				)}
			</div>
		</div>
	);
};

const MyPatients = (props) => {
	const DATA = props?.mypatients?.results || [];

	const updateFilters = (e) => {
		updateMyPatients({ filters: { ...props?.mypatients?.filters, ...e } });
	};

	const updateMyPatients = (e) => {
		props.updateMyPatientsFilters({ ...props?.mypatients, ...e });
	};

	const load = () => {
		props.updateRecords({ ...props?.mypatients });
	};

	const gotoPage = (page) => {
		props.updateRecords({ page });
	};

	React.useEffect(() => {
		load();
	}, []);

	return (
		<Layout title={"My Patients"} permissions={PERMISSIONS.doctor}>
			<div className="user-grid-toolbar">
				<div className="control has-icon">
					<input
						className="input custom-text-filter"
						placeholder="Search..."
						data-filter-target=".column"
					/>
					<div className="form-icon">
						<i data-feather="search" />
					</div>
				</div>
			</div>
			<div className="page-content-inner">
				<div className="user-grid user-grid-v1">
					{/*List Empty Search Placeholder */}
					{DATA?.length < 1 ? (
						<div className="page-placeholder custom-text-filter-placeholder">
							<div className="placeholder-content">
								<img
									className="light-image"
									src={
										require("../../../assets/img/illustrations/placeholders/search-4.svg")
											.default
									}
									alt=""
								/>
								<h3>We couldn't find any matching results.</h3>
								<p className="is-larger">
									Too bad. Looks like we couldn't find any matching results for
									the search terms you've entered. Please try different search
									terms or criteria.
								</p>
							</div>
						</div>
					) : (
						<div className="columns is-multiline">
							{/*Grid item*/}
							{DATA.map((e) => {
								return (
									<MyPatientItem
										{...e}
										openPanel={props.openPanel}
										key={v4()}
									/>
								);
							})}
						</div>
					)}
				</div>
			</div>
		</Layout>
	);
};

const mapStateToProps = ({ mypatients }) => {
	return { mypatients };
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateMyPatientsFilters: (e) => dispatch(updateMyPatientsFilters(e)),
		updateRecords: (e) => dispatch(updateRecords(e)),
    	openPanel: (e) => dispatch(openPanel(e)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MyPatients);
